import { type UseQueryResult, useQuery } from 'react-query';
import { CustomerUserApprovalService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetSystemUserApprovalStatusList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const getCustomerUserCustomerUserApprovalStatusList = useQuery(
    ['getCustomerUserCustomerUserApprovalStatusList'],
    async () => {
      return await handleRequest(
        CustomerUserApprovalService.getApiCustomerApiAppCustomerUserApprovalCustomerUserStatusList()
      );
    },
    {
      select: (data) => {
        const options = data?.map((item) => {
          return {
            label: item.status ?? '',
            value: item.statusId ?? '',
          };
        });

        const sortOptions = options?.concat({ label: 'All', value: 0 }).sort(function (a, b) {
          return a.label.localeCompare(b.label);
        });
        return sortOptions;
      },
    }
  );

  return getCustomerUserCustomerUserApprovalStatusList;
};

export default useGetSystemUserApprovalStatusList;
